import SkeletonBar from "../shared/SkeletonBar";
import { DividedList, DividedListItem } from "../shared/ContentList";

export function PostListItemSkeleton() {
    return (
        <DividedListItem aria-hidden>
            <div className="mb-3 flex items-center justify-between gap-3">
                <SkeletonBar className="h-4 w-32" />
                <SkeletonBar className="h-4 w-28" />
            </div>
            <div className="space-y-2">
                <SkeletonBar className="h-4 w-full" />
                <SkeletonBar className="h-4 w-full" />
                <SkeletonBar className="h-4 w-4/5" />
            </div>
            <SkeletonBar className="mt-3 h-4 w-2/3" />
            <div className="mt-4 flex flex-wrap gap-3">
                <SkeletonBar className="h-6 w-24 rounded-md" />
                <SkeletonBar className="h-6 w-28 rounded-md" />
            </div>
        </DividedListItem>
    );
}

export default function PostListSkeletons({
    count = 5,
    className = "",
    label = "Loading posts",
}) {
    return (
        <DividedList
            className={className}
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <PostListItemSkeleton key={index} />
            ))}
        </DividedList>
    );
}
